import { SettingsItem } from '@/screens/settings/components/settings-item';
import { useRouter } from 'expo-router';
import React from 'react';
import type { CustomEntry } from '../registry';

interface SettingCustomRowProps {
  entry: CustomEntry;
  isLast?: boolean;
  gatedDisabled?: boolean;
}

/**
 * A bespoke settings row. Either renders its own component (`render`) or acts as
 * a navigation row to an existing screen (`route`). A permission-gated row is
 * disabled and never navigates. "Not built yet" is expressed by a feature flag
 * on the entry (which hides the row), never by a disabled placeholder.
 */
export function SettingCustomRow({
  entry,
  isLast = false,
  gatedDisabled = false,
}: SettingCustomRowProps) {
  const router = useRouter();

  if (entry.render) {
    return entry.render();
  }

  return (
    <SettingsItem
      isLast={isLast}
      item={{
        testID: `custom-${entry.id}`,
        icon: entry.icon,
        title: entry.label,
        disabled: gatedDisabled,
        destructive: entry.destructive,
        action: () => {
          if (gatedDisabled || !entry.route) return;
          router.push(entry.route as never);
        },
      }}
    />
  );
}
